import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { WHATSAPP_LINK } from "../data/site";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-float-button"
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Parsn Group on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lift"
  >
    <MessageCircle size={26} strokeWidth={2} />
  </motion.a>
);
